import _capitalize from 'capitalize';
import emojiStrip from 'emoji-strip';
import _md5 from 'md5';
import NameCase from 'namecase';
import _removeAccents from 'remove-accents';
import { camelCase as camelCase$1, kebabCase as kebabCase$1, snakeCase as snakeCase$1 } from 'scule';
import _slugify from 'slugify';
import stringSimilarity from 'string-similarity';
import _truncate from 'truncate';

function camelCase(input) {
  if (input.includes(" ")) {
    input = input.split(" ").map((word) => capitalize(word, true)).join("");
  }
  return camelCase$1(input);
}
function capitalize(string, firstLetterOnly) {
  return firstLetterOnly ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : _capitalize.words(string);
}
function clean(string) {
  return (string || "").replace(/‎/g, "").replace(/\s\s+/g, " ").replace(/−/g, "-").replace(/–/g, "-").trim();
}
function findFirstNumber(string) {
  const number = string.trim().replace(/(\d)\s+(?=\d)/g, "").replace(/,/g, "").split(/\s/).find((item) => {
    return !Number.isNaN(Number.parseInt(item));
  });
  return number ? Number.parseInt(number) : null;
}
function generateUUID() {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  };
  return `${s4()}-${s4()}-${s4()}-${s4()}`;
}
function getSimilarity(string1, string2) {
  return stringSimilarity.compareTwoStrings(string1, string2);
}
function hideCharacters(string, charactersToKeep) {
  return string.split("").reduce((accumulator, letter) => {
    return accumulator.length < (charactersToKeep || 0) || letter === " " ? accumulator + letter : `${accumulator}\u2022`;
  }, "");
}
function isAscii(string) {
  return /^[\x00-\x7F]*$/.test(string);
}
function isNumeric(string) {
  if (typeof string != "string") {
    return false;
  }
  return !Number.isNaN(string) && !Number.isNaN(Number.parseFloat(string));
}
function kebabCase(input) {
  return kebabCase$1(input);
}
function linkify(string = "", newTab = true) {
  let replacedText = "";
  const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = string.replace(replacePattern1, `<a href="$1" ${newTab ? 'target="_blank"' : null}>$1</a>`);
  const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, `$1<a href="http://$2" ${newTab ? 'target="_blank"' : null}>$2</a>`);
  const replacePattern3 = /(([a-zA-Z0-9\-_\.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
  return replacedText;
}
function md5(input) {
  return _md5(input);
}
function nameCase(fullName) {
  return NameCase(fullName);
}
function pascalCase(input) {
  const result = camelCase(input);
  return result.charAt(0).toUpperCase() + result.slice(1);
}
function removeAccents(string) {
  return _removeAccents(string);
}
function removeEmojis(string) {
  return emojiStrip(string).replace(" \u200D", "").replace(/\s\s+/g, " ").trim();
}
function removeUnicodeCharacters(string) {
  return (string || "").replace(/[^ \nA-Za-z0-9À-ÖØ-öø-ÿЀ-ӿ-]+/g, "").trim();
}
function slugify(string, replacement = "-") {
  string = string.replace(/^\./, "dot ");
  string = string.replace(/\./g, replacement);
  string = string.replace(/\//g, replacement);
  string = string.replace(/\#/g, "-sharp");
  string = string.replace(/\+/g, "-plus");
  return _slugify(string, {
    lower: true,
    replacement,
    strict: true
  });
}
function snakeCase(string) {
  return snakeCase$1(string);
}
function truncate(string, maxLength) {
  return _truncate(string, maxLength - 1);
}
function unslugify(string, lowercase) {
  string = string.replace(/-|_/g, " ");
  if (lowercase) {
    string = string.toLowerCase();
  }
  return string;
}
function formatBytes(bytes, decimals = 2) {
  if (!+bytes) {
    return "0 Bytes";
  }
  const kilobytes = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    "Bytes",
    "Kb",
    "Mb",
    "Gb",
    "Tb",
    "Pb",
    "Eb",
    "Zb",
    "Yb"
  ];
  const exponent = Math.floor(Math.log(bytes) / Math.log(kilobytes));
  return `${Number.parseFloat((bytes / kilobytes ** exponent).toFixed(dm))}${sizes[exponent]}`;
}
const byteSize = (str) => new Blob([str]).size;
const mbSize = (str) => byteSize(str) / 1048576;
function truncateStringToMb(str, maxSizeInMb = 1) {
  const maxBytes = maxSizeInMb * 1048576;
  const totalBytes = byteSize(str);
  if (totalBytes <= maxBytes) {
    return str;
  }
  const estimatedSafeLength = Math.floor(str.length * maxBytes / totalBytes);
  return str.substring(0, estimatedSafeLength);
}
function sanitizeDbName(name) {
  return name.replace(/[\/-]/g, "_");
}
function extractBranchName(input) {
  const regex = /^pull\/([0-9]+)\/head$/;
  const match = input.match(regex);
  if (match) {
    return match[1];
  } else {
    return input;
  }
}

export { byteSize, camelCase, capitalize, clean, extractBranchName, findFirstNumber, formatBytes, generateUUID, getSimilarity, hideCharacters, isAscii, isNumeric, kebabCase, linkify, mbSize, md5, nameCase, pascalCase, removeAccents, removeEmojis, removeUnicodeCharacters, sanitizeDbName, slugify, snakeCase, truncate, truncateStringToMb, unslugify };
